import { initialize } from '@doordash/lib-feature-flags'
import { createI18nInstance, Locale } from '@doordash/lib-i18n'
import { has } from 'lodash'
import { TranslationStringKey } from 'translationTypes'
import defaultFeatureFlags from '../defaultFeatureFlags'
import experimentToFeatureFlagMap from '../experimentToFeatureFlagMap'
import * as englishAustraliaStrings from './translations/en-AU.json'
import * as englishCanadaStrings from './translations/en-CA.json'
import * as englishStrings from './translations/en-US.json'
import * as spanishStrings from './translations/es.json'
import * as frenchStrings from './translations/fr-CA.json'
import * as japaneseStrings from './translations/ja-JP.json'
import * as germanGermanyStrings from './translations/de-DE.json'

declare const window

if (has(window, 'view.experiments')) {
  initialize(
    experimentToFeatureFlagMap,
    defaultFeatureFlags,
    window.view.experiments,
    window.view.featureFlagOverrides
  )
}

const localizedStrings = {
  [Locale.EN_US]: englishStrings,
  [Locale.ES]: spanishStrings,
  [Locale.FR_CA]: frenchStrings,
  [Locale.EN_AU]: englishAustraliaStrings,
  [Locale.EN_CA]: englishCanadaStrings,
  [Locale.JA]: japaneseStrings,
  [Locale.DE_DE]: germanGermanyStrings,
}

const i18n = createI18nInstance({ localizedStrings })

export default {
  ...i18n,
  t: (key: TranslationStringKey, options?: {}) => i18n.t(key, options),
}
